const coursesData = [
  {
    id: 1,
    slug: "numerology",

    title: "Numerology Courses",

    image: "https://i.pinimg.com/1200x/82/ad/da/82adda028ad944391a15e4665265c861.jpg",

    shortDescription:
      "Master Basic to Advanced Numerology with practical prediction techniques.",

    overview:
      "This course covers Pythagorean Numerology, Lo Shu Grid, Mobile Numerology and Business Name Numerology from beginner to advanced level.",

    duration: "3 Months",

    level: "Beginner to Advanced",

    language: "Hindi",

    certificate: "Yes",

    features: [
      "Basic to Advanced Numerology",
      "Mobile Numerology",
      "Business & Name Numerology",
     
    ],

    syllabus: [
      {
        module: "Module 1",
        topics: [
          "Introduction to Numerology",
          "Life Path Number",
          "Destiny Number",
          "Soul Number",
        ],
      },

      {
        module: "Module 2",
        topics: [
          "Pythagorean System",
          "Missing Numbers",
          "Master Numbers",
        ],
      },

      {
        module: "Module 3",
        topics: [
          "Lo Shu Grid",
          "Grid Analysis",
          "Personality Reading",
        ],
      },

      {
        module: "Module 4",
        topics: [
          "Mobile Numerology",
          "Lucky Numbers",
          "Business Numbers",
        ],
      },

      {
        module: "Module 5",
        topics: [
          "Business Name Numerology",
          "Brand Numerology",
          "Practical Case Studies",
        ],
      },
    ],

    benefits: [
      "Professional Prediction Skills",
      "Client Consultation",
      "Business Name Selection",
      "Mobile Number Analysis",
      "Certificate",
    ],

    recorded: {
      price: "₹9,999",
      duration: "Lifetime Access",
      support: "WhatsApp Support",
    },

    live: {
      price: "₹14,999",
      batch: "Every Month",
      duration: "3 Months",
      support: "Live Doubt Sessions",
    },
  },

  {
    id: 2,

    slug: "vedic-astrology",

    title: "Vedic Astrology",

    image: "https://i.pinimg.com/736x/dc/51/2f/dc512ffc00393a366afba9e897445b03.jpg",

    shortDescription:
      "Complete Jyotish Course from Beginner to Advanced.",

    features: [
      "yotish Parichay",
      "Advanced Predictive Astrology",
      "Gochar & Mahadasha Analysis",
    ],
  },

  {
    id: 3,

    slug: "vastu",

    title: "Vastu Shastra",

    image: "https://i.pinimg.com/736x/6e/f3/a3/6ef3a3792fc89e992cfdace89b3b887e.jpg",

    shortDescription:
      "Residential & Commercial Vastu with practical remedies.",

    features: [
      "Foundation Vastu",
      "Commercial & Industrial Vastu",
      "Astro-Vastu & Remedies",
    ],
  },

  {
    id: 4,

    slug: "workshops",

    title: "Remedial & Calculation Workshops",

    image: "https://i.pinimg.com/736x/46/11/80/461180441b83257364150949bc113baa.jpg",

    shortDescription:
      "Muhurat, Rudraksha and Crystal Masterclasses.",

    features: [
      "Muhurat Shastra",
      "Rudraksh Masterclass",
      "Crystals Masterclass",
    ],
  },
];

export default coursesData;